'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

var _datamasterForms = require("datamaster-forms");

var _formInputs = require("./../form-inputs");

var _modal = _interopRequireDefault(require("../modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

/**
 *
 * @param target
 */
var scrollTo = function scrollTo(target) {
  var destination = document.getElementById(target);
  var container = document.querySelector('.app-content');
  var offset = 0;

  if (destination.offsetParent) {
    offset += destination.offsetParent.offsetTop;
  }

  offset += destination.offsetTop;
  setTimeout(function () {
    container.scrollTo(0, offset);
  }, 200);
};

var LgwForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(LgwForm, _BaseForm);

  function LgwForm(props) {
    var _this;

    _classCallCheck(this, LgwForm);

    _this = _possibleConstructorReturn(this, (LgwForm.__proto__ || Object.getPrototypeOf(LgwForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      lgwNotFound: !props.project,
      lgwEdit: false,
      lgw: props.project,
      product: [],
      availability: [],
      offer: [],
      lgwIsSaving: {},
      form: {
        isEditable: false,
        error: {
          project: {}
        },
        invalidFields: {
          project: {
            fields: [],
            details: {}
          }
        },
        success: {}
      },
      offerToDelete: null,
      deleting: false
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.addOffer = _this.addOffer.bind(_assertThisInitialized(_this));
    _this.onRemoveOffer = _this.onRemoveOffer.bind(_assertThisInitialized(_this));
    _this.removeOffer = _this.removeOffer.bind(_assertThisInitialized(_this));
    _this.saveOffer = _this.saveOffer.bind(_assertThisInitialized(_this));
    _this.onProjectInputChange = _this.onProjectInputChange.bind(_assertThisInitialized(_this));
    _this.saveProject = _this.saveProject.bind(_assertThisInitialized(_this));
    _this.renderRemoveModal = _this.renderRemoveModal.bind(_assertThisInitialized(_this));
    _this.onGeocode = _this.onGeocode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LgwForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var loadRelatedDataCollection = function loadRelatedDataCollection(url, name) {
        // Load categories and subcategories
        fetch(url, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (objects) {
          _this2.setState(function (prev) {
            prev[name] = objects;
            return prev;
          });
        }).catch(console.error);
      }; // Load project related data


      loadRelatedDataCollection(_conf.default.api.lgwProductApiUrlTemplate(this.props.i18n.language), 'product');
      loadRelatedDataCollection(_conf.default.api.availabilityApiUrlTemplate(this.props.i18n.language), 'availability');
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      this.state.availability = [{
        id: 1,
        name: t('Januar')
      }, {
        id: 2,
        name: t('Februar')
      }, {
        id: 3,
        name: t('März')
      }, {
        id: 4,
        name: t('April')
      }, {
        id: 5,
        name: t('Mai')
      }, {
        id: 6,
        name: t('Juni')
      }, {
        id: 7,
        name: t('Juli')
      }, {
        id: 8,
        name: t('August')
      }, {
        id: 9,
        name: t('September')
      }, {
        id: 10,
        name: t('Oktober')
      }, {
        id: 11,
        name: t('November')
      }, {
        id: 12,
        name: t('Dezember')
      }];
      var texts = {
        sectionOffers: {
          sectionTitle: t('offers'),
          save: t('Speichern')
        },
        sectionOther: {
          sectionTitle: t('Sonstiges'),
          openingHours: t('Öffnungszeiten'),
          comments: t('Bemerkung'),
          save: t('Speichern')
        },
        offer: {
          remove: t('Angebot entfernen'),
          save: t('Speichern'),
          product: t('product'),
          pleaseChoose: t('Bitte wählen'),
          yes: this.props.t('yes'),
          no: this.props.t('no')
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-farm comp-base-form comp-vomhof"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Lgw",
        className: "form-title"
      }, t('Project data')), this.state.lgwNotFound && /*#__PURE__*/_react.default.createElement("p", null, t('Not registered')), !_lodash.default.isEmpty(this.state.lgw) ? /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectLgwForm, {
        t: t,
        handleInputChange: this.handleInputChange,
        handleOfferChange: this.handleInputChange,
        onProjectInputChange: this.onProjectInputChange,
        addOffer: this.addOffer,
        saveOffer: this.saveOffer,
        removeOffer: this.onRemoveOffer,
        saveProject: this.saveProject,
        onGeocode: this.onGeocode,
        shared: {
          loading: {
            products: false
          },
          lgwProducts: this.state.product,
          months: this.state.availability
        },
        project: this.state.lgw,
        progress: {},
        texts: texts,
        error: this.state.form.error,
        invalidFields: this.state.form.invalidFields,
        success: this.state.form.success,
        isSaving: this.state.lgwIsSaving,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputSelect: _formInputs.AdapterSelect,
        InputField: _formInputs.AdapterText,
        InputTextarea: _formInputs.TextareaInput,
        InputRadioGroup: _formInputs.InputRadioGroup,
        InputCheckbox: _formInputs.CheckboxInput,
        scrollTo: scrollTo
      }) : null, this.state.offerToDelete && this.renderRemoveModal(this.state.offerToDelete, this.removeOffer, 'offerToDelete', 'confirm-remove-offer', 'Angebot wirklich entfernen?'));
    }
    /**
     *
     * @param isOpen
     * @param removeFunction
     * @param stateProperty
     * @param id
     * @returns {*}
     */

  }, {
    key: "renderRemoveModal",
    value: function renderRemoveModal(isOpen, removeFunction, stateProperty, id, heading) {
      var _this3 = this;

      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: id,
        classes: 'confirm-remove-offer-class',
        isOpen: isOpen,
        backgroundClickClose: true,
        escClose: true
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, t(heading)), /*#__PURE__*/_react.default.createElement("div", {
        className: 'button-group'
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "button inline-style",
        onClick: function onClick() {
          return _this3.setState(function (prev) {
            prev[stateProperty] = null;
            return prev;
          });
        }
      }, t('no')), /*#__PURE__*/_react.default.createElement("button", {
        className: "button inline-style",
        onClick: function onClick() {
          return removeFunction();
        }
      }, t('yes')))), this.state.deleting && /*#__PURE__*/_react.default.createElement(_datamasterForms.Loader, {
        size: 'medium'
      }));
    }
    /**
     *
     * @param type
     * @param id
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(type, id, fieldName, value) {
      var changeTypeArray = this.state.lgw[type];

      var firstIndex = _lodash.default.findIndex(changeTypeArray, {
        id: id
      });

      this.setState(function (prev) {
        prev.lgw[type][firstIndex][fieldName] = value;
        return prev;
      });
    }
    /**
     *
     */

  }, {
    key: "addOffer",
    value: function addOffer(productId) {
      var _this4 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.lgwAddOffer(this.props.i18n.language, this.props.id), {
        method: 'POST',
        body: JSON.stringify({
          product_id: productId
        }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedProduct) {
        _this4.setState(function (prev) {
          prev.lgw.offers.push(updatedProduct);
          prev.lgw.offers.sort(function (offerA, offerB) {
            // sort empty products at the top
            if (!offerA.product || !offerA.product.name) {
              return -1;
            }

            if (!offerA.product || !offerB.product.name) {
              return 1;
            }

            return offerA.product.name.localeCompare(offerB.product.name);
          });
          return prev;
        });

        return Promise.resolve({
          value: updatedProduct
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this4.setState(function (prev) {
          prev.form = {
            error: {
              project: message
            },
            invalidFields: {
              project: {
                fields: Object.keys(invalidFields),
                details: invalidFields
              }
            },
            success: {}
          };
          return prev;
        });
      });
    }
    /**
     *
     * @returns {Promise<Response>}
     */

  }, {
    key: "saveProject",
    value: function saveProject(section) {
      var _this5 = this;

      section = section || 'general';
      this.setState(function (prev) {
        prev.lgwIsSaving[section] = true;
        return prev;
      });

      var projectData = _lodash.default.cloneDeep(this.state.lgw);

      if (this.state.lgw.offers.length === 0) {
        return this.setState(function (prev) {
          prev.form.error[section] = 'lgw product error';
          prev.form.invalidFields[section] = {
            fields: Object.keys('delivery'),
            details: 'required lgw'
          };
          prev.form.success[section] = false;
          prev.lgwIsSaving[section] = false;
          return prev;
        });
      } // eslint-disable-next-line


      if (!Boolean(this.state.lgw.collection) && !Boolean(this.state.lgw.delivery)) {
        return this.setState(function (prev) {
          prev.form.error[section] = 'required';
          prev.form.invalidFields[section] = {
            fields: Object.keys('delivery'),
            details: 'required'
          };
          prev.form.success[section] = false;
          prev.lgwIsSaving[section] = false;
          return prev;
        });
      }

      return fetch(_conf.default.api.lgwUpdateProject(this.props.i18n.language, this.props.id), {
        method: 'PUT',
        body: JSON.stringify(projectData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this5.setState(function (prev) {
          prev.lgwIsSaving[section] = false;

          if (!prev.form) {
            prev.form = {
              isEditable: false,
              error: {
                general: null,
                other_outlets: null
              },
              invalidFields: {
                general: {
                  fields: [],
                  details: {}
                },
                offers: {
                  fields: [],
                  details: {}
                }
              },
              success: {}
            };
          }

          prev.form.success[section] = true;
          prev.form.error[section] = null;
          prev.form.invalidFields[section] = {
            fields: [],
            details: []
          };
          return prev;
        });

        setTimeout(function () {
          _this5.setState(function (prev) {
            prev.form.success[section] = false;
            return prev;
          });
        }, 3000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this5.setState(function (prev) {
          prev.form.error[section] = message;
          prev.form.invalidFields[section] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success[section] = false;
          prev.lgwIsSaving[section] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param name
     * @param value
     */

  }, {
    key: "onProjectInputChange",
    value: function onProjectInputChange(name, value) {
      this.setState(function (prev) {
        prev.lgw[name] = value;
        return prev;
      });
    }
    /**
     *
     * @param offerId
     */

  }, {
    key: "saveOffer",
    value: function saveOffer(offerId) {
      var _this6 = this;

      if (!this.props.id) {
        return void 0;
      }

      this.setState(function (prev) {
        prev.lgwIsSaving[offerId] = true;
        return prev;
      });
      var index = this.state.lgw.offers.findIndex(function (offer) {
        return offer.id === offerId;
      });

      var offer = _lodash.default.cloneDeep(this.state.lgw.offers[index]);

      return fetch(_conf.default.api.lgwUpdateOffer(this.props.i18n.language, this.props.id, offerId), {
        method: 'PUT',
        body: JSON.stringify(offer),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this6.setState(function (prev) {
          prev.lgwIsSaving[offerId] = false;
          prev.form.success[offerId] = true;
          delete prev.form.error[offerId];
          delete prev.form.invalidFields[offerId];
          return prev;
        });

        setTimeout(function () {
          _this6.setState(function (prev) {
            prev.form.success[offerId] = false;
            return prev;
          });
        }, 3000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this6.setState(function (prev) {
          prev.form.error[offerId] = message;
          prev.form.invalidFields[offerId] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success[offerId] = false;
          prev.lgwIsSaving[offerId] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param offerId
     * @returns {*}
     */

  }, {
    key: "onRemoveOffer",
    value: function onRemoveOffer(offerId) {
      if (!this.props.id) {
        return void 0;
      }

      this.setState(function (prev) {
        prev.offerToDelete = offerId;
        return prev;
      });
    }
    /**
     *
     * @returns {Promise<Response>|void}
     */

  }, {
    key: "removeOffer",
    value: function removeOffer() {
      var _this7 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.lgwUpdateOffer(this.props.i18n.language, this.props.id, this.state.offerToDelete), {
        method: 'DELETE',
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (offerRemoved) {
        _this7.setState(function (prev) {
          prev.lgw.offers = prev.lgw.offers.filter(function (offer) {
            return offer.id !== offerRemoved.offerRemoved;
          });
          prev.offerToDelete = null;
          prev.deleting = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param outletId
     */

  }, {
    key: "onGeocode",
    value: function onGeocode(outletId) {
      var index = this.props.project.outlets.findIndex(function (outlet) {
        return outlet.id === outletId;
      });
      var outlet = this.props.project.outlets[index];
      var geoData = [outlet.street, outlet.zip + ' ' + outlet.city];
      var fullAddress = geoData.join(', ');
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        address: fullAddress
      }, function (res, status) {
        if (status === 'OK') {
          this.handleInputChange('outlets', outletId, 'latitude', res[0].geometry.location.lat());
          this.handleInputChange('outlets', outletId, 'longitude', res[0].geometry.location.lng());
        } else {
          void 0;
        }
      }.bind(this));
    }
    /**
     *
     */

  }, {
    key: "resetEditMode",
    value: function resetEditMode() {
      this.setState(function (prev) {
        prev.form = {
          isEditable: false,
          error: {
            project: null
          },
          invalidFields: {
            project: {
              fields: [],
              details: {}
            }
          },
          success: {}
        };
        return prev;
      });
    }
  }]);

  return LgwForm;
}(_baseForm.default);

var _default = (0, _translate.default)(LgwForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/lgw/lgw.js
// module id = 723
// module chunks = 0